import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import styles from '../../styles/Progress.module.css';
const ACHIEVEMENT_XP = 25;
export function AchievementPopup({ achievements, onClose }) {
    const [currentIndex, setCurrentIndex] = useState(0);
    useEffect(() => {
        setCurrentIndex(0);
    }, [achievements]);
    if (achievements.length === 0)
        return null;
    const current = achievements[currentIndex];
    const isLast = currentIndex >= achievements.length - 1;
    const handleNext = () => {
        if (isLast) {
            onClose();
        }
        else {
            setCurrentIndex((i) => i + 1);
        }
    };
    return (_jsx("div", { className: styles.popupOverlay, onClick: onClose, children: _jsxs("div", { className: styles.popupCard, onClick: (e) => e.stopPropagation(), children: [_jsx("div", { className: styles.popupIcon, children: current.icon }), _jsx("div", { className: styles.popupTitle, children: "\uD83C\uDFC6 \u0410\u0447\u0438\u0432\u043A\u0430 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0430!" }), _jsx("div", { className: styles.popupName, children: current.name }), _jsx("div", { className: styles.popupDesc, children: current.description }), _jsxs("div", { className: styles.popupXp, children: ["+", ACHIEVEMENT_XP, " XP"] }), _jsx("button", { className: styles.popupBtn, onClick: handleNext, children: isLast ? 'Отлично!' : 'Далее →' }), achievements.length > 1 && (_jsxs("div", { className: styles.popupCounter, children: [currentIndex + 1, " / ", achievements.length] }))] }) }));
}
